import qs from 'qs';
import { AxiosInstance } from 'axios';
import {
    AuthSchemaFilterInput,
    AuthenticateWithEmailAndPasswordInput,
    AuthenticateWithGoogleTokenInput,
} from './inputs';
import { AuthSessionResource, AuthSchemaResource, SignInAttemptResultResource } from './resources';

export default class Auth {
    private basePath = '/api/auth';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetch email schema
    getEmailSchema = async (filter: AuthSchemaFilterInput): Promise<AuthSchemaResource> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/schema/email?${query}`);

        return data;
    };

    // Authenticate using email and password pair
    authenticateWithEmailAndPassword = async (
        input: AuthenticateWithEmailAndPasswordInput
    ): Promise<SignInAttemptResultResource> => {
        const { data } = await this.http.post(`${this.basePath}/type/email-password`, input);

        return data;
    };

    // Authenticate using token, received after "Login with Google" flow
    authenticateWithGoogleToken = async (
        input: AuthenticateWithGoogleTokenInput
    ): Promise<SignInAttemptResultResource> => {
        const { data } = await this.http.post(`${this.basePath}/type/google`, input);

        return data;
    };
}
